/* Imports */
import axios from "../api/api";
/* /Imports/ */

/* 
  Class: TeamService
  Description: This class is responsible for teams stuff.
*/
class TeamService {
    /* 
      Obtain all teams from the api.
    */
    async getAllTeams() {
        const response = await axios.get("api/teams", {
            headers: {
                Authorization:
                    "ZMR9NXavD9tTYHvr4PPVIACuWxjvezPzpn0GryMYzI7wCB43d4s3gNu5gyic8oB12hxZZ7ZzSpbHnfKTdA4NoUZ4WgUUbj5Oqy7t1kk29E2fU44gxTxW5NYwP4rg7Z7gkUawbaNb6MDM98Vdp104v68z9H7P19gFkts63i3iia82rffzeDx2345SuzWCcMeXdiJmbXRxDUByGZObK2C43az5rzlpabOyhH50tsAhEH6FFavSa0QVLQCdyIMMsDe",
            },
        });

        return response;
    }

    /* 
      Obtain single team from the api.
    */
    async getTeam(id) {
        const response = await axios.get("api/teams/" + id, {
            headers: {
                Authorization:
                    "ZMR9NXavD9tTYHvr4PPVIACuWxjvezPzpn0GryMYzI7wCB43d4s3gNu5gyic8oB12hxZZ7ZzSpbHnfKTdA4NoUZ4WgUUbj5Oqy7t1kk29E2fU44gxTxW5NYwP4rg7Z7gkUawbaNb6MDM98Vdp104v68z9H7P19gFkts63i3iia82rffzeDx2345SuzWCcMeXdiJmbXRxDUByGZObK2C43az5rzlpabOyhH50tsAhEH6FFavSa0QVLQCdyIMMsDe",
            },
        });

        return response;
    }

    /* 
      Obtain user teams from the api.
    */
    getMyTeams(token) {
        return axios.get("api/teams/user", {
            headers: {
                Authorization: token,
            },
        }).then((response) => {
            return response;
        });
    }

    /* 
      Create new team from the api.
    */
    createTeam(data) {
        return axios.post("api/teams/create", data, {
            headers: {
                Authorization:
                    "ZMR9NXavD9tTYHvr4PPVIACuWxjvezPzpn0GryMYzI7wCB43d4s3gNu5gyic8oB12hxZZ7ZzSpbHnfKTdA4NoUZ4WgUUbj5Oqy7t1kk29E2fU44gxTxW5NYwP4rg7Z7gkUawbaNb6MDM98Vdp104v68z9H7P19gFkts63i3iia82rffzeDx2345SuzWCcMeXdiJmbXRxDUByGZObK2C43az5rzlpabOyhH50tsAhEH6FFavSa0QVLQCdyIMMsDe",
            },
        }).then((response) => {
            return response.data;
        });
    }

    /* 
      Update certain team from the api.
    */
    updateTeam(id, data) {
        return axios.post("api/teams/" + id + "/update", data, {
            headers: {
                Authorization:
                    "ZMR9NXavD9tTYHvr4PPVIACuWxjvezPzpn0GryMYzI7wCB43d4s3gNu5gyic8oB12hxZZ7ZzSpbHnfKTdA4NoUZ4WgUUbj5Oqy7t1kk29E2fU44gxTxW5NYwP4rg7Z7gkUawbaNb6MDM98Vdp104v68z9H7P19gFkts63i3iia82rffzeDx2345SuzWCcMeXdiJmbXRxDUByGZObK2C43az5rzlpabOyhH50tsAhEH6FFavSa0QVLQCdyIMMsDe",
            },
        }).then((response) => {
            return response.data;
        });
    }

    /* 
      Delete certain team from the api.
    */
    deleteTeam(id) {
        return axios.delete("api/teams/" + id + "/delete", {
            headers: {
                Authorization:
                    "ZMR9NXavD9tTYHvr4PPVIACuWxjvezPzpn0GryMYzI7wCB43d4s3gNu5gyic8oB12hxZZ7ZzSpbHnfKTdA4NoUZ4WgUUbj5Oqy7t1kk29E2fU44gxTxW5NYwP4rg7Z7gkUawbaNb6MDM98Vdp104v68z9H7P19gFkts63i3iia82rffzeDx2345SuzWCcMeXdiJmbXRxDUByGZObK2C43az5rzlpabOyhH50tsAhEH6FFavSa0QVLQCdyIMMsDe",
            },
        }).then((response) => {
            return response.data;
        });
    }

    /* 
      Invite member/members to certain team from the api.
    */
    inviteMember(id, data) {
        return axios.post("api/teams/" + id + "/invite", data, {
            headers: {
                Authorization:
                    "ZMR9NXavD9tTYHvr4PPVIACuWxjvezPzpn0GryMYzI7wCB43d4s3gNu5gyic8oB12hxZZ7ZzSpbHnfKTdA4NoUZ4WgUUbj5Oqy7t1kk29E2fU44gxTxW5NYwP4rg7Z7gkUawbaNb6MDM98Vdp104v68z9H7P19gFkts63i3iia82rffzeDx2345SuzWCcMeXdiJmbXRxDUByGZObK2C43az5rzlpabOyhH50tsAhEH6FFavSa0QVLQCdyIMMsDe",
            },
        }).then((response) => {
            return response.data;
        });
    }

    /* 
      Remove member/members from certain team from the api.
    */
    removeMember(id, data) {
        return axios.post("api/teams/" + id + "/remove", data, {
            headers: {
                Authorization:
                    "ZMR9NXavD9tTYHvr4PPVIACuWxjvezPzpn0GryMYzI7wCB43d4s3gNu5gyic8oB12hxZZ7ZzSpbHnfKTdA4NoUZ4WgUUbj5Oqy7t1kk29E2fU44gxTxW5NYwP4rg7Z7gkUawbaNb6MDM98Vdp104v68z9H7P19gFkts63i3iia82rffzeDx2345SuzWCcMeXdiJmbXRxDUByGZObK2C43az5rzlpabOyhH50tsAhEH6FFavSa0QVLQCdyIMMsDe",
            },
        }).then((response) => {
            return response.data;
        });
    }

    /* 
      Assign incident/incidents to certain team from the api.
    */
    assignIncident(id, data) {
        return axios.post("api/teams/" + id + "/incidents", data, {
            headers: {
                Authorization:
                    "ZMR9NXavD9tTYHvr4PPVIACuWxjvezPzpn0GryMYzI7wCB43d4s3gNu5gyic8oB12hxZZ7ZzSpbHnfKTdA4NoUZ4WgUUbj5Oqy7t1kk29E2fU44gxTxW5NYwP4rg7Z7gkUawbaNb6MDM98Vdp104v68z9H7P19gFkts63i3iia82rffzeDx2345SuzWCcMeXdiJmbXRxDUByGZObK2C43az5rzlpabOyhH50tsAhEH6FFavSa0QVLQCdyIMMsDe",
            },
        }).then((response) => {
            return response.data;
        });
    }

    /* 
      Remove incident/incidents from certain team from the api.
    */
    removeIncident(id, data) {
        return axios.post("api/teams/" + id + "/incidents/remove", data, {
            headers: {
                Authorization:
                    "ZMR9NXavD9tTYHvr4PPVIACuWxjvezPzpn0GryMYzI7wCB43d4s3gNu5gyic8oB12hxZZ7ZzSpbHnfKTdA4NoUZ4WgUUbj5Oqy7t1kk29E2fU44gxTxW5NYwP4rg7Z7gkUawbaNb6MDM98Vdp104v68z9H7P19gFkts63i3iia82rffzeDx2345SuzWCcMeXdiJmbXRxDUByGZObK2C43az5rzlpabOyhH50tsAhEH6FFavSa0QVLQCdyIMMsDe",
            },
        }).then((response) => {
            return response.data;
        });
    }

    /* 
      Assign role/roles to certain team from the api.
    */
    assignRole(id, data) {
        return axios.post("api/teams/" + id + "/roles", data, {
            headers: {
                Authorization:
                    "ZMR9NXavD9tTYHvr4PPVIACuWxjvezPzpn0GryMYzI7wCB43d4s3gNu5gyic8oB12hxZZ7ZzSpbHnfKTdA4NoUZ4WgUUbj5Oqy7t1kk29E2fU44gxTxW5NYwP4rg7Z7gkUawbaNb6MDM98Vdp104v68z9H7P19gFkts63i3iia82rffzeDx2345SuzWCcMeXdiJmbXRxDUByGZObK2C43az5rzlpabOyhH50tsAhEH6FFavSa0QVLQCdyIMMsDe",
            },
        }).then((response) => {
            return response.data;
        });
    }

    /* 
      Remove role/roles from certain team from the api.
    */
    removeRole(id, data) {
        return axios.post("api/teams/" + id + "/roles/remove", data, {
            headers: {
                Authorization:
                    "ZMR9NXavD9tTYHvr4PPVIACuWxjvezPzpn0GryMYzI7wCB43d4s3gNu5gyic8oB12hxZZ7ZzSpbHnfKTdA4NoUZ4WgUUbj5Oqy7t1kk29E2fU44gxTxW5NYwP4rg7Z7gkUawbaNb6MDM98Vdp104v68z9H7P19gFkts63i3iia82rffzeDx2345SuzWCcMeXdiJmbXRxDUByGZObK2C43az5rzlpabOyhH50tsAhEH6FFavSa0QVLQCdyIMMsDe",
            },
        }).then((response) => {
            return response.data;
        });
    }
}

export default new TeamService();
